import { getScopeActions } from './scopeActionMap';
import { createScopedDispatchers } from '../../shared/selectHandlers/createScopedDispatchers';

export const selectSpecificLocationDispatchHandler = (
  dispatch, scope, name, specificLocationList, machineList,
  newSpecificLocations, newMachines
) => {
  const { selectSpecificLocationDispatch } = createScopedDispatchers(getScopeActions(scope), 'controller');
  selectSpecificLocationDispatch(dispatch, name, specificLocationList, machineList, newSpecificLocations, newMachines);
};
